/**
 * Sysnet API
 *  ## Authorization We use bearer auth throughout the API. Generally, API requests should have the follow header:   {       \"content-type\": \"application/json\",       \"Authorization\": \"Bearer TOKEN_GOES_HERE\"   }   Please refer to the Auth section immediately below for details on getting your token.
 *
 * OpenAPI spec version: 1.0.4
 * Contact: support@hlpos.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface LocationsListViewTaxName { 
    /**
     * The unique identifier of this record.
     */
    taxNameId?: number;
    salesTax0Code?: string;
    salesTax1Code?: string;
    salesTax2Code?: string;
    salesTax3Code?: string;
    wholesaleTax0Name?: string;
    wholesaleTax1Name?: string;
    wholesaleTax2Name?: string;
    wholesaleTax3Name?: string;
}